// extracted by mini-css-extract-plugin
export default {"root":"PageNavigation_root__pzr7U"};